import React from 'react'
import { TERMS_OF_USE_LINK } from 'root-constants'
import { eventLogger } from 'services/eventLogger.service'
import { useTranslation } from 'react-i18next'
import { OuterLink } from 'components/OuterLink'

export const TermsOfUseLink: React.FC = () => {
  const { t } = useTranslation()

  return (
    <OuterLink
      href={TERMS_OF_USE_LINK}
      onClick={() => eventLogger.logTermsOfUseClicked()}
    >
      {t('commonComponents.termsOfUse')}
    </OuterLink>
  )
}
